<template>
	<div class="d-flex flex-wrap row">
		<div class="d-flex flex-wrap col-12 col-md-6">
			<div style="width: 100%;">
				<button class="tab-block__button" :class="!searchTabOpen ? 'tab-block__button--selected' : ''" type="button" @click="searchTabOpen = false;">Senast valda taggar</button>
				<button class="tab-block__button" :class="searchTabOpen ? 'tab-block__button--selected tab-block__button--white' : ''" type="button" @click="searchTabOpen = true;">Sök</button>
			</div>
			<div class="tab-block tab-block--left" v-show="!searchTabOpen">
				<template v-if="unpickedTags.length">
					<div class="tag form-group--checkbox" v-for="tag in unpickedTags" :key="'popular' + tag.id">
						<input type="checkbox" :id="tag.id" :disabled="chosen.length > 9" v-model="tag.toggled" @click="toggleChosen(tag)"> <label :for="tag.id">{{ tag.name }}</label>
					</div>
				</template>
				<div v-else>Det finns inga fler populära taggar. Testa att söka efter en.</div>
			</div>
			<div class="tab-block tab-block--search" v-show="searchTabOpen">
				<input type="text" v-model="search" placeholder="Sök tag" class="tag-search" @keydown.enter.prevent="performSearch()">

				<div v-if="addTag">
					Taggen finns inte, vill du lägga till den?

					<button @click="postTag()" type="button">Ja</button>
					<button @click="addTag=false" type="button">Nej</button>
				</div>

				<div class="tag form-group--checkbox" v-for="tag in unpickedSearchedTags" :key="'search' + tag.id">
					<input type="checkbox" :id="tag.id" v-model="tag.toggled" @click="toggleChosen(tag)"> <label :for="tag.id">{{ tag.name }}</label>
				</div>
			</div>
		</div>
		<div class="d-flex flex-wrap col-12 col-md-6">
			<div style="width: 100%;">
				<button class="tab-block__button tab-block__button--selected tab-block__button--white" disabled type="button">Dina valda taggar</button>
			</div>
			<div class="tab-block">
				<div class="tag form-group--checkbox" v-for="tag in chosen" :key="'chosen' + tag.id">
					<input type="checkbox" :id="tag.id" v-model="tag.toggled" @click="toggleChosen(tag)" name="tags[]" :value="tag.id"> <label :for="tag.id">{{ tag.name }}</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['tags', 'selected'],
		data() {
			return {
				allTags: this.tags,
				chosen: this.selected,
				searchTabOpen: false,
				search: '',
				timeout: null,
				results: [],
				addTag: false,
			}
		},
		computed: {
			unpickedTags() {
				return this.allTags.filter(tag => {
					return !this.chosenHas(tag);
				})
			},
			unpickedSearchedTags() {
				return this.results.filter(tag => {
					return !this.chosenHas(tag);
				})
			}
		},
		watch: {
			search() {
				this.performSearch();
			}
		},
		methods: {
			toggleChosen(tag) {
				const indexOfTag = this.chosen.indexOf(tag);
				if(indexOfTag === -1) {
					tag.toggled = true;
					this.chosen.push(tag);
				} else {
					tag.toggled = false;
					this.chosen.splice(indexOfTag, 1);
				}
			},
			chosenHas(tag) {
				return this.chosen.find(chosen => {
					return chosen.id === tag.id;
				}) !== undefined;
			},
			performSearch() {
				clearTimeout(this.timeout);
				if(this.search.length >= 3) {
					this.timeout = setTimeout(() => {
						axios.get('/api/tags?q=' + this.search).then(response => {
							this.results = response.data.data;

							if(this.results.length == 0) {
								this.askPostTag();
							}
						})
					}, 300);
				}
			},
			askPostTag() {
				this.addTag = true;
			},
			postTag() {
				axios.post('/api/tags', {name: this.search}).then(response => {
					response.data.toggled = true;

					this.chosen.push(response.data);
					this.addTag = false;
					this.search = "";
				})
			}
		}
	}
</script>